import { bindable } from 'aurelia-framework';

export class CustomFieldsCustomElement {
	@bindable fields: any;
	@bindable validationPath: any;
	@bindable disableFormFields: any = false;
	rows: any;

	constructor() {
		this.rows = [];
	}

	bind() {
		this.buildRows();
	}

	fieldsChanged(newValue, oldValue) {
		this.buildRows();
	}

	buildRows() {
		this.rows = [];
		if (this.fields) {
			let row = -1;
			for (let ii = 0; ii < this.fields.length; ++ii) {
				if (this.fields[ii].visible) {
					if (row === -1 || this.rows[row].length === 3) {
						this.rows.push(new Array());
						row += 1;
					}
					if (!this.fields[ii].label) { this.fields[ii].label = `Custom Field ${ii + 1}`; }
					this.rows[row].push(this.fields[ii]);
				}
			}
		}
	}
}
